import { makeStyles } from '@material-ui/core/styles';

export const perfiladorCotizationStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: '#FFFFFF',
    paddingLeft: 'unset',
    paddingRight: 'unset',
  },
  tab: {
    fontSize: '14px',
    fontFamily: 'Open Sans',
    fontWeight: '600',
    lineHeight: '14px',
    whiteSpace: 'nowrap',
    minHeight: '35px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '17px',
      lineHeight: '24px',
      minHeight: '40px',
    },
  },
  btn: {
    fontSize: '18px',
    fontFamily: 'Open Sans',
    fontWeight: '700',
    lineHeight: '18px',
    textAlign: 'center',
    color: '#000',
    backgroundColor: '#FFA500',
    borderRadius: '40px',
    padding: '20px 44px',
  },
  gridRight: {
    border: '1px solid #E2DBDB',
    borderRadius: '10px',
    [theme.breakpoints.up('sm')]: {
      border: 'none',
      borderRadius: '0px',
      paddingLeft: '30px !important',
      paddingRight: '30px !important',
      borderLeft: '1px solid #7C839D',
    },
  },
  subtitleConditions: {
    color: '#313132',
    textAlign: 'center',
  },
  valueClassName: {
    color: '#313132',
  },
  titleClassName: {
    color: '#313132',
  },
  input: {
    marginBottom: '15px',
    [theme.breakpoints.up('sm')]: {
      marginBottom: '0px',
    },
  },
  title: {
    color: '#313132',
    marginBottom: '15px',
    [theme.breakpoints.up('sm')]: {
      marginBottom: '0px',
    },
  },
}));
